// extracted by mini-css-extract-plugin
export default {"LoadingIndicator":"LoadingIndicator_LoadingIndicator__cTW6r","lds-ring":"LoadingIndicator_lds-ring__xyLEN"};